import { onValue, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { realtimeDB } from "../Backend";

const TutorialPlayer = () => {
    const [tutUrl,setTutUrl]=useState(null);
    const {tuts, id} = useParams();

    useEffect(()=>{
        onValue(ref(realtimeDB,`${tuts}/${id}/url`),(snapshot)=>{
            if(snapshot.exists()){
                setTutUrl(snapshot.val());
            }
        });
    },[tuts,id]);

    return (  
        <div className="tutplayer">
            <video src={tutUrl} controls autoPlay/>
        </div>
    );
}
export default TutorialPlayer;